import React from 'react'

import LinkToUrl from 'components/LinkToUrl'
import { IBrandItem } from 'store/entities/Brands/Brand.normalizer'
import styled from 'styled-components'
import { granite } from 'uiComponents/constants/colors'
import {
  mediaDesktopAndUp,
  mediaExtraLargeScreens,
} from 'uiComponents/constants/customMedia'
import Like from '../Like'

const BrandLink = styled(LinkToUrl)`
  display: flex;
  justify-content: space-between;
  padding: 4px 18px;
  text-transform: uppercase;

  > span {
    color: ${granite};
  }
`

const Brand: React.FC<{
  brand: IBrandItem
  isLiked: boolean
  onClick: VoidFunction
}> = ({ brand, isLiked, onClick }) => (
  <Wrapper onClick={onClick}>
    <BrandLink to={brand.attributes.url}>
      {brand.attributes.name}
      <span>{brand.attributes.productCount}</span>
    </BrandLink>
    <StyledLike
      $isLiked={isLiked}
      liked={isLiked}
      brandId={brand.id}
      brandUrl={brand.attributes.url}
    />
  </Wrapper>
)

const StyledLike = styled(Like)<{ $isLiked: boolean }>`
  position: absolute;
  top: 5px;
  right: 80px;
  visibility: ${({ $isLiked }) => ($isLiked ? 'visible' : 'hidden')};

  @media ${mediaDesktopAndUp} {
    right: 120px;
  }

  @media ${mediaExtraLargeScreens} {
    right: 150px;
  }
`

const Wrapper = styled.div`
  position: relative;
  margin: 4px 0;

  &:hover {
    background: #f4f4f5;

    ${StyledLike} {
      visibility: visible;
    }
  }
`

export default Brand
